String.prototype.toDate = function(): Date {
    return new Date(this);
};

String.prototype.toValueOnEmptyOrUndefined = function(toValue: string): string {
    return this.toString() ? this.toString() : toValue;
};